import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { IagPortalFeedbackAndSuggestionsPage } from 'src/app/model/page/group/iag-portal/iag-portal-feedback-and-suggestions-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-iag-portal-feedback-and-suggestions-page',
  templateUrl: './iag-portal-feedback-and-suggestions-page.component.html',
  styleUrls: ['./iag-portal-feedback-and-suggestions-page.component.scss']
})
export class IagPortalFeedbackAndSuggestionsPageComponent implements OnInit {
  iagPortalFeedbackAndSuggestionsPage: IagPortalFeedbackAndSuggestionsPage = {} as IagPortalFeedbackAndSuggestionsPage;
  pageName: any;
  //mapEntryToSubBodySection: any;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'iag-portal-feedback') {
        this.iagPortalFeedbackAndSuggestionsPage.htmlTitle = title.htmlTitle;
      }
    });
    this.iagPortalFeedbackAndSuggestionsPage.sections = [];
    const query = { 'fields.title': 'Feedback and suggestions' };
    this.contentfulService.getPageContentResponse(query).then((iagPortalFeedbackAndSuggestionsPageEntries) => {
      this.mapBanner(iagPortalFeedbackAndSuggestionsPageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.iagPortalFeedbackAndSuggestionsPage.banner);
      this.mapPageInfo(iagPortalFeedbackAndSuggestionsPageEntries.items);
      this.mapSections(iagPortalFeedbackAndSuggestionsPageEntries.includes.Entry);
    });

    // console.log(this.iagPortalFeedbackAndSuggestionsPage);
  }

  private mapBanner(iagPortalFeedbackAndSuggestionsPageEntries: Entry<any>[]) {
    iagPortalFeedbackAndSuggestionsPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
		let video: any = entry.fields['video'] as string;
	   this.iagPortalFeedbackAndSuggestionsPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url,
      video: video?.fields?.file?.url
	  }
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.iagPortalFeedbackAndSuggestionsPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.iagPortalFeedbackAndSuggestionsPage.banner.url = entry.fields?.url;
      this.iagPortalFeedbackAndSuggestionsPage.banner.editorEmail = editorDetails?.pop();
      this.iagPortalFeedbackAndSuggestionsPage.banner.editorShortName = editorDetails?.pop();
      this.iagPortalFeedbackAndSuggestionsPage.banner.editorFullName = editorDetails?.pop();
      this.iagPortalFeedbackAndSuggestionsPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapSections(iagPortalFeedbackAndSuggestionsPageEntries: Entry<any>[]) {
    iagPortalFeedbackAndSuggestionsPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
        //this.mapEntryToSubBodySection(entry);
      });

    this.iagPortalFeedbackAndSuggestionsPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    // console.log(entry);
    let title:any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    this.iagPortalFeedbackAndSuggestionsPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      subBody: entry?.fields?.['subBody'] as string
    });
  }
}
